import { Injectable } from "@angular/core";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { EMPTY } from "rxjs";
import { tap } from "rxjs/operators";
import { VehicleFunctionsApiService } from "src/app/services/api/vehicle-functions-api.service";
import { VehicleFunctionsStateModel } from "./vehicleFunctions.state.model";
import { VehicleFunctionsActions } from "./vehicleFunctions.actions";

@State<VehicleFunctionsStateModel>({
    name: 'vehicleFunctions',
    defaults: {
        vehicleFunctions: []
    },
})
@Injectable()
export class VehicleFunctionsState{
    constructor(private vehicleFunctionsApiService: VehicleFunctionsApiService) {}

    @Action(VehicleFunctionsActions.SetAllVehicleFunctions)
    SetAllVehicleFunctions(ctx: StateContext<VehicleFunctionsStateModel>) {
        const state = ctx.getState();
        //don't update state if we have already downloaded items
        if (state.vehicleFunctions && state.vehicleFunctions.length > 0)
            return EMPTY;

        return this.vehicleFunctionsApiService.get().pipe(
            tap(vehicleFunctions => {
                if (vehicleFunctions) {
                  var allVehicleFunctions = vehicleFunctions;
                  ctx.patchState({vehicleFunctions: allVehicleFunctions});
                }
            })
        );
    }

    @Selector()
    static getAllVehicleFunctions(state: VehicleFunctionsStateModel){
        return state.vehicleFunctions;
    }
}
